import type { Dayjs } from "dayjs"
import dayjs from "dayjs"

const parseJsonValue = <T>(value: unknown, fallback: T): unknown | T => {
  if (typeof value !== "string") {
    return value ?? fallback
  }

  const trimmed = value.trim()
  if (!trimmed) {
    return fallback
  }

  const startsLikeJson =
    (trimmed.startsWith("{") && trimmed.endsWith("}")) ||
    (trimmed.startsWith("[") && trimmed.endsWith("]"))

  if (!startsLikeJson) {
    return value
  }

  try {
    return JSON.parse(trimmed)
  } catch (_error) {
    return fallback
  }
}

const mapObjectField = (value: unknown): Record<string, unknown> => {
  if (value === null || value === undefined || value === "") {
    return {}
  }

  return parseJsonValue(value, {}) as Record<string, unknown>
}

const mapArrayField = <T = any>(value: unknown): T[] => {
  if (value === null || value === undefined || value === "") {
    return []
  }

  const parsed = parseJsonValue(value, [])
  return Array.isArray(parsed) ? parsed : []
}

const mapDateField = (value: unknown): Dayjs | null => {
  if (!value) {
    return null
  }

  const parsed = dayjs(value as any)
  return parsed.isValid() ? parsed : null
}

const normalizeApiPayload = (value: any): any => value?.data ?? value ?? null

export { mapArrayField, mapDateField, mapObjectField, normalizeApiPayload }
